import { PRODUCT_ATTRIBUTE } from '../const/attribute';
import { UNIT_OF_MEASUREMENT } from '../const/unit_of_measurement';
import { titleArray } from './productHelper';

export const isAttribute = (product, attributeName) => {
  const attribute = product[attributeFieldName(attributeName)];
  if (!attribute || attribute == 'null' || attribute == 'undefined') {
    return false;
  }
  return true;
};

const attributeFieldName = (attributeName) => {
  if (attributeName === PRODUCT_ATTRIBUTE.SIZE) {
    return 'size';
  }
  return '';
};

export const getUomDisplayVal = (uom) => {
  if (!uom || uom === 'null' || uom === 'undefined') {
    return '';
  }
  if (uom === 'UNIT') {
    return '';
  }
  return UNIT_OF_MEASUREMENT[uom] ? UNIT_OF_MEASUREMENT[uom] : 'G';
};

const isInteger = (x) => {
  return x % 1 === 0;
};

export const getNumberViewVal = (value) => {
  if (isNaN(value)) {
    return value;
  }

  if (isInteger(value)) {
    return parseInt(value);
  }

  // Strip off trailing zeros
  if (typeof value === "string") {
    return Number(value)
  }

  return value;
};

export const isSize = product => {
  return product.size && product.size !== 'null';
}

export const isWeight = product => product.weight && product.weight > 0;

export const isMedium = product => !!product.medium;

export const isMgDose = product => !!product.mgDose;

export const isTotalDose = product => !!product.totalDoses;

export const getProductAttribute = (product, attributeName) => product.attributeMap && product.attributeMap[attributeName] ? product.attributeMap[attributeName] : [];

export const getProductAttributes = (product) => {
  const delimiter = ', ';
  const general = titleArray(getProductAttribute(product, PRODUCT_ATTRIBUTE.GENERAL)).join(delimiter);
  const flavors = titleArray(getProductAttribute(product, PRODUCT_ATTRIBUTE.FLAVOR)).join(delimiter);
  const effects = titleArray(getProductAttribute(product, PRODUCT_ATTRIBUTE.EFFECT)).join(delimiter);
  const ingredients = titleArray(getProductAttribute(product, PRODUCT_ATTRIBUTE.INGREDIENT)).join(delimiter);

  return {
    general, flavors, effects, ingredients,
  };
};



// WEBPACK FOOTER //
// ./src/helpers/attribute_util.js